// Force landing starts at top - fix auto-scroll on Shopify
if (history.scrollRestoration) history.scrollRestoration = 'manual';
if (location.hash) history.replaceState(null, '', location.pathname + location.search);
window.addEventListener('DOMContentLoaded', () => window.scrollTo(0, 0));
window.addEventListener('load', () => setTimeout(() => window.scrollTo({top: 0, left: 0, behavior: 'instant'}), 10));

// Gallery thumbs -> main image swap (per gallery)
document.querySelectorAll(".aquaracer-root .gallery").forEach(gallery => {
  const main = gallery.querySelector("#main-product-image");
  const buttons = gallery.querySelectorAll(".thumbs button");
  buttons.forEach(button => button.addEventListener("click", () => {
    buttons.forEach(b => b.classList.remove("active"));
    button.classList.add("active");
    const src = button.dataset.image;
    if (main && src) main.src = src;
  }));
});

// Scroll reveal with stagger delay
const observer = new IntersectionObserver(entries => entries.forEach(entry => {
  if (entry.isIntersecting) {
    const delay = parseInt(entry.target.dataset.delay || "0", 10);
    entry.target.style.transitionDelay = delay * 90 + "ms";
    entry.target.classList.add("is-visible");
    observer.unobserve(entry.target);
  }
}), { threshold: 0.12, rootMargin: "0px 0px -40px 0px" });
document.querySelectorAll(".aquaracer-root [data-reveal]").forEach(el => observer.observe(el));

// Sticky bar on scroll past hero
const stickyBar = document.getElementById("aquaracer-sticky-bar");
const hero = document.getElementById("hero");
const footer = document.querySelector("footer.footer, .footer, #shopify-section-footer");
if (stickyBar && hero) {
  const stickyObserver = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) {
        stickyBar.style.display = "flex";
        requestAnimationFrame(() => stickyBar.classList.add("is-visible"));
      } else {
        stickyBar.classList.remove("is-visible");
        stickyBar.style.display = "none";
      }
    });
  }, { threshold: 0 });
  stickyObserver.observe(hero);

  // Hide when footer visible
  if (footer) {
    const footerObserver = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          stickyBar.classList.add("is-hidden");
        } else {
          stickyBar.classList.remove("is-hidden");
        }
      });
    }, { threshold: 0.1 });
    footerObserver.observe(footer);
  }
}

// FAQ accordion - accessible
document.querySelectorAll(".faq-question").forEach(btn => {
  btn.addEventListener("click", () => {
    const expanded = btn.getAttribute("aria-expanded") === "true";
    const answer = document.getElementById(btn.getAttribute("aria-controls"));
    // Close all others
    document.querySelectorAll(".faq-question").forEach(b => {
      if (b !== btn) {
        b.setAttribute("aria-expanded", "false");
        const a = document.getElementById(b.getAttribute("aria-controls"));
        if (a) a.classList.remove("open");
      }
    });
    btn.setAttribute("aria-expanded", !expanded);
    if (answer) {
      if (expanded) {
        answer.classList.remove("open");
      } else {
        answer.classList.add("open");
      }
    }
  });
});

// WhatsApp per-ad-source greeting
(function () {
  const source = new URLSearchParams(location.search).get("utm_source");
  const messages = {
    google: "Halo PGJ Watches, saya sedang mencari TAG Heuer Aquaracer CAY1110.FT6041. Apakah stoknya ready sekarang?",
    meta: "Halo PGJ Watches! Saya baru lihat iklan TAG Heuer Aquaracer dan langsung tertarik. Boleh minta info ketersediaan dan harganya?"
  };
  const text = messages[source];
  if (!text) return;
  const encoded = encodeURIComponent(text);
  document.querySelectorAll(".aquaracer-root a[href^='https://wa.me/']").forEach(a => {
    const base = a.href.split("?")[0];
    a.href = base + "?text=" + encoded;
  });
})();

// Tracking - dataLayer and gtag
(function () {
  const productName = 'TAG Heuer Aquaracer CAY1110.FT6041';
  const productSku = 'CAY1110.FT6041';
  const productPrice = 43200000;
  const pageType = 'campaign_landing_page';

  function pushEvent(eventName, ctaLocation) {
    // dataLayer
    if (typeof window.dataLayer !== 'undefined') {
      window.dataLayer.push({
        event: eventName,
        product_name: productName,
        product_sku: productSku,
        product_price: productPrice,
        page_type: pageType,
        cta_location: ctaLocation
      });
    }
    // gtag GA4
    if (typeof gtag === 'function') {
      gtag('event', eventName, {
        product_name: productName,
        product_sku: productSku,
        product_price: productPrice,
        page_type: pageType,
        cta_location: ctaLocation
      });
    }
  }

  document.querySelectorAll(".aquaracer-root [data-track-event]").forEach(el => {
    el.addEventListener("click", function(e) {
      const eventName = this.dataset.trackEvent;
      const ctaLocation = this.dataset.ctaLocation || 'unknown';
      pushEvent(eventName, ctaLocation);
    });
  });
})();
